import { render, staticRenderFns } from "./ProductEditGroupsLight.vue?vue&type=template&id=7805fc5f"
import script from "./ProductEditGroupsLight.vue?vue&type=script&lang=ts"
export * from "./ProductEditGroupsLight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports